// frontend entry point
import { initAddFavoriteOnInquiry } from './scripts/init/addFavoriteOnInquiry';
import './scripts/init/localization';
import { initAuth } from './scripts/lib/supabase/authInit';
import './scripts/lib/ToastManager';
import './scripts/react-habitat/init';
import './styles/frontend.scss';

initAuth();
initAddFavoriteOnInquiry();
